import styled from "styled-components";

export const Book = styled.div`
    width: 100%;
    height: calc(100vh - 70px);
    overflow-y: auto;
    position: relative;
    scroll-behavior: smooth;

    @media print {
        height: auto;
        
        @page {
            size: A4;
            margin: 0px;
        }
    }

    a.Book__back_to_sumario {
        position: fixed;
        right: 20px;
        bottom: 20px;
        width: 35px;
        height: 35px;
        border: none;
        background: var(--primary-color);
        color: #fff;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        @media print {
            display: none;
        }
    }

    div.Book__loading {
        width: 228mm;
        height: calc(100vh - 50px);
        background: rgba(255,255,255,0.9);
        position: fixed;
        right: 0;
        top: 50px;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;